import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";

import * as _ from "lodash";

import * as Papi from "@app/papi";

import {RestServiceApi} from "./restServiceApi";

@Injectable()
export class Service implements RestServiceApi {
	constructor(private httpClient: HttpClient, private papi: Papi.Service) {
	}

	public get basepath(): string {
		return "";
	}

	public delete<Result>(endpoint: string, id: string | number): Observable<Result> {
		return this.request<Result>("delete", `${endpoint}/${encodeURIComponent(String(id))}`);
	}

	public get<Result>(endpoint: string, id?: string | number): Observable<Result> {
		if (!_.isNil(id)) {
			endpoint += `/${encodeURIComponent(String(id))}`;
		}
		return this.request<Result>("get", endpoint);
	}

	public patch<Result>(endpoint: string, body: any): Observable<Result> {
		return this.request<Result>("patch", endpoint, body);
	}

	public post<Result>(endpoint: string, body?: any): Observable<Result> {
		return this.request<Result>("post", endpoint, body);
	}

	public request<Result>(method: string, endpoint: string, body?: any, params?: HttpParams, reportProgress: boolean = false): Observable<Result> {
		let headers: HttpHeaders = new HttpHeaders();

		if (this.papi.authenticate.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.papi.authenticate.configuration.apiKeys["Authorization"]);
		}
		// headers = headers.set("Access-Control-Allow-Origin", "*");
		// headers = headers.set("Access-Control-Allow-Methods", "get, post, patch, put, delete, options");
		// headers = headers.set("Access-Control-Allow-Headers", "*");
		headers = headers.set("Content-Type", "application/json");


		return this.httpClient.request<Result>(method, `${this.basepath}/${endpoint}`, {
			params: params,
			body: body,
			withCredentials: this.papi.authenticate.configuration.withCredentials,
			headers: headers,
			observe: "body",
			reportProgress: reportProgress,
			responseType: "json"
		});
	}
}
